module.exports = __webpack_public_path__ + "img/1482821983.c20e1f24.jpg";